import React, { useState } from "react";
import { IAddEbook } from "../../Ebook.props";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import useAddEbook from "./useAddEbook";

const AddEbook: React.FC = () => {
  const {
    formData,
    loading,
    languages,
    courses,
    subjectName,
    standard,
    isPhyiscalBookAvailable,
    handleChange,
    handleSubmit,
    handleCancel,
  } = useAddEbook();

  const [filteredSubjects, setFilteredSubjects] = useState(subjectName);
  const [filteredCourses, setFilteredCourses] = useState(courses);

  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
  } = useForm<IAddEbook>();

  const handleStandardChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedStandard = e.target.value;
    handleChange(e); // Update the form data
    if (selectedStandard) {
      const filtered = courses.filter(
        (course) => course.standard === selectedStandard
      );
      setFilteredCourses(filtered);
    } else {
      setFilteredCourses(courses); // Reset if no standard selected
    }
  };

  const handleCourseChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCourse = e.target.value;
    handleChange(e); // Update the form data
    if (selectedCourse) {
      const filtered = subjectName.filter(
        (subject) =>subject.courseName === selectedCourse 
      );
      setFilteredSubjects(filtered);
    } else {
      setFilteredSubjects(subjectName); // Reset if no standard selected
    }
  };

  const fields = [
    { label: "Language", name: "languageName", type: "select", options: languages },
    { label: "Education", name: "standard", type: "select", options: standard },
    { label: "Stream", name: "courseName", type: "select", options: filteredCourses },
    { label: "Subject", name: "subject", type: "select", options: filteredSubjects },
    { label: "Book Name", name: "bookName", type: "text", required:true },
    { label: "Price", name: "eBookPrice", type: "number", required:false },
    { label: "Is Physical Book Available ?", name: "isPhysicalBookAvailable", type: "select", options: isPhyiscalBookAvailable },
    { label: "Physical Book Price", name: "physicalBookPrice", type: "number", required:false },
    { label: "Description", name: "description", type: "text", required:true },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Add Ebook</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label className="block text-gray-700 text-base font-semibold mb-2" htmlFor={field.name}>
                    {field.label}:
                  </label>
                  {field.type === "select" ? (
                    <select
                      id={field.name}
                      {...register(field.name, { required: true })}
                      onChange={
                        field.name === "standard" ? handleStandardChange :
                        field.name === "courseName" ? handleCourseChange :
                        handleChange
                      }
                      disabled={(field.name === "subject" && !formData.courseName) || (field.name === "courseName" && !formData.standard)} // Disable "Subject" if "Standard" not selected
                      className={`appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline ${
                        (field.name === "subject" && !formData.courseName) || (field.name === "courseName" && !formData.standard) ? "bg-gray-200 cursor-not-allowed" : ""
                      }`}
                    >
                      <option value="">Select {field.label}</option>
                      {field.options.map((option) => (
                        <option key={option._id} value={option[field.name]}>
                          {option[field.name]}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      id={field.name}
                      {...register(field.name, { required: field.required })}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                  )}
                  {errors[field.name] && (
                    <span className="text-red-500 text-xs italic">
                      {field.label} field is required
                    </span>
                  )}
                </div>
              ))}

              {/* File inputs */}
              <div>
                <label className="block text-gray-700 text-base font-semibold mb-2" htmlFor="imageUrl">
                  Image URL:
                </label>
                <input
                  {...register('imageUrl', { required: true })}
                  className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                  type="file"
                  id="imageUrl"
                  onChange={handleChange}
                />
                {errors?.imageUrl && (
                    <span className="text-red-500 text-xs italic">
                      Image URL is required
                    </span>
                  )}
              </div>

              <div>
                <label className="block text-gray-700 text-base font-semibold mb-2" htmlFor="pdfUrl">
                  PDF URL:
                </label>
                <input
                  {...register('pdfUrl', { required: true })}
                  className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                  type="file"
                  id="pdfUrl"
                  onChange={handleChange}
                />
                {errors?.pdfUrl && (
                    <span className="text-red-500 text-xs italic">
                      PDF URL is required
                    </span>
                  )}
              </div>
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton className="py-2 px-4 rounded mr-4" type="submit">
              ADD
            </FormButton>
            <CancelButton className="py-2 px-4 rounded" onClick={handleCancel} type="button">
              Cancel
            </CancelButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEbook;
